import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Badge, Center, Spinner, Icon, PageHeader } from "@/components/ui";
import { Topbar } from "@/components/Layout";
import { api } from "@/lib/api";

export default function Availability() {
  const nav = useNavigate();
  const [candidates, setCandidates] = useState([]);
  const [selected, setSelected] = useState(new Set());
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try { const d = await api.get("/office/interview-availability"); setCandidates(d.candidate_slots || []); setSelected(new Set(d.has_custom ? d.available_slots : d.candidate_slots)); }
    catch (e) { setMsg(e.message); } finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const toggle = (s) => setSelected((prev) => { const n = new Set(prev); n.has(s) ? n.delete(s) : n.add(s); return n; });
  const save = async () => {
    setBusy(true);
    try { const r = await api.post("/office/interview-availability", { slots: Array.from(selected) }); setMsg(`Saved ${r.count} open slots. Applicants now see only these.`); setTimeout(() => setMsg(null), 3500); }
    catch (e) { setMsg(e.message); } finally { setBusy(false); }
  };

  if (loading) return <div className="screen"><Topbar title="Interview availability" /><Center><Spinner /></Center></div>;
  const byDay = {};
  candidates.forEach((s) => { const day = new Date(s).toLocaleDateString([], { weekday: "long", month: "short", day: "numeric" }); (byDay[day] = byDay[day] || []).push(s); });

  return (
    <div className="screen" data-testid="availability-screen">
      <Topbar title="Interview availability" subtitle="Phone · 20 min slots" />
      <div className="container-narrow">
        <PageHeader title="Interview availability" onBack={() => nav("/office")} />
        {msg ? <div className="toast" data-testid="availability-toast">{msg}</div> : null}
        <p className="note">Tap to toggle the slots you're available for. Applicants who need a phone interview will only see these.</p>
        {Object.entries(byDay).map(([day, slots]) => (
          <div key={day} style={{ marginBottom: 12 }}>
            <div className="section-label">{day.toUpperCase()}</div>
            <div className="time-slots">{slots.map((s) => {
              const on = selected.has(s);
              return <button key={s} className={`time-slot${on ? " selected" : ""}`} data-testid={`avail-${s}`} onClick={() => toggle(s)}><Icon name={on ? "check" : "plus"} size={13} /> {new Date(s).toLocaleTimeString([], { hour: "numeric" })}</button>;
            })}</div>
          </div>
        ))}
        <Button testID="availability-save" label={`Publish ${selected.size} slots`} onClick={save} loading={busy} />
      </div>
    </div>
  );
}
